module.exports = {
    password: 'Passwords must be at least six characters and match the confirmation.',
    reset: 'Your password has been reset!',
    sent: 'We have emailed your password reset link!',
    token: 'This password reset token is invalid.',
    user: "We can't find a user with that email address.",
    password_too_short: 'The password must be at least 6 characters.',
    password_mismatch: 'The password must match the confirmation field.'
}